import { render, staticRenderFns } from "./EmployeeGroupTableControl.vue?vue&type=template&id=10afa67c&scoped=true&"
import script from "./EmployeeGroupTableControl.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afa67c",
  null
  
)

export default component.exports